import { render, staticRenderFns } from "./CardValidaFace.vue?vue&type=template&id=2560b08c&scoped=true"
import script from "./CardValidaFace.vue?vue&type=script&lang=js"
export * from "./CardValidaFace.vue?vue&type=script&lang=js"
import style0 from "./CardValidaFace.vue?vue&type=style&index=0&id=2560b08c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2560b08c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2560b08c')) {
      api.createRecord('2560b08c', component.options)
    } else {
      api.reload('2560b08c', component.options)
    }
    module.hot.accept("./CardValidaFace.vue?vue&type=template&id=2560b08c&scoped=true", function () {
      api.rerender('2560b08c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LivenessHiveDetail/components/CardValidaFace.vue"
export default component.exports